// extracted by mini-css-extract-plugin
module.exports = {"parallax":"__07-HeroB_parallax__dboyn","overlay":"__07-HeroB_overlay___yUH1"};